// src/components/operationCenter/widgets/CommoditiesMoversWidget.tsx
// Commodities Movers Widget for Operation Center

import React from "react";
import type { WidgetProps } from "@/types/dashboard";
import CommoditiesMoversCard from "@/components/macro/commodities/CommoditiesMoversCard";
import useFXCommodities from "@/hooks/macro/useFXCommodities";
import type { FxCommodity } from "@/types/dashboards/macro";

export interface CommoditiesMoversConfig {
  direction: "gainers" | "losers";
}

const CommoditiesMoversWidget: React.FC<
  WidgetProps<CommoditiesMoversConfig>
> = ({ widget }) => {
  const config = widget.config as CommoditiesMoversConfig;
  const direction = config.direction ?? "gainers";

  const { data, isLoading } = useFXCommodities();

  // Filter for commodities only
  const commoditiesData = React.useMemo(() => {
    if (!data) return [];
    return data.filter((item: FxCommodity) => item.asset_type === "commodity");
  }, [data]);

  const title = direction === "gainers" ? "Commodity Gainers" : "Commodity Losers";

  return (
    <div className="h-full overflow-hidden">
      <CommoditiesMoversCard
        title={title}
        data={commoditiesData}
        isLoading={isLoading}
        direction={direction}
        fillHeight
        limit={10}
      />
    </div>
  );
};

export default CommoditiesMoversWidget;
